<p>check-out-order-type-fields works!</p>
